import { AbstractNode } from '@/orrm/model/index'
import Path from '@/orrm/path'
import Geometry from '@/orrm/Geometry'

export class Commune extends AbstractNode {
  protected jsonApiType = 'taxonomy_term/orrm_commune'

  get name (): string {
    return this.getAttribute('name')
  }

  get path (): Path {
    return this.getAttribute('path')
  }

  get geometry (): Geometry {
    return this.getAttribute('field_orrm_geometrie')
  }
}
